import React from 'react'
import { Checkbox } from 'antd'

function NextBoxDiaryHeader(props) {
    const { selectedAll, handleChangeSelectAll} = props
    return (
        <thead className="TableHead NextBoxDiaryHeader">
            <tr>
                <td><Checkbox checked={selectedAll} onChange={(e)=>handleChangeSelectAll(e.target.checked)} /></td>
                <td>Ngày rời xưởng</td>
                <td>Tổng số thùng</td>
                <td>Item VN</td>
                <td>Ghi chú</td>
            </tr>
        </thead>
    )
}

export default NextBoxDiaryHeader